// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"SelectGroupStep_wrapper_3vOG2"};